"use client";
import { Blog } from "@/lib/@types/api/blog";
import BlogList from "./BlogList";
import { Pagination } from "antd";
import { useEffect, useState } from "react";
import { getBlogList } from "@/lib/api/blog";

// 异步获取博客列表，确保是一个 Promise
async function fetchBlogList(
	Params: Blog.GetBlogListParams,
): Promise<{ blogList: Blog.BlogListItem[]; blogCount: number }> {
	try {
		const res = await getBlogList(Params);
		return { blogList: res.detail.blog_list, blogCount: res.detail.blog_filter_count };
	} catch (error) {
		console.error("Error fetching blog list:", error);
		return { blogList: [], blogCount: 0 }; // 如果发生错误，返回一个空数组
	}
}

const BlogContent = ({ params }: { params: { locale: string; slug: string } }) => {
	const limit = 6;
	const [pageSize, setPageSize] = useState(1);
	const [blogList, setBlogList] = useState<Blog.BlogListItem[]>([]);
	const [blogCount, setBlogCount] = useState<number>(1);
	// 从 API 获取博客列表和分类

	useEffect(() => {
		fetchBlogList({
			lang_code: { lang_code: params.locale },
			page: pageSize,
			limit,
			cls_slug_in: [{ slug: params.slug }],
		}).then((res) => {
			setBlogCount(res.blogCount);
			setBlogList(res.blogList);
		});
	}, [pageSize]);
	const onChange = (page: number) => {
		// 页码更改处理逻辑
		pageSize !== page && setPageSize(page);
	};

	return (
		<>
			<BlogList blogList={blogList} />
			{blogCount > 1 && (
				<div className="mt-6 flex w-full items-center justify-center md:mt-10">
					<Pagination defaultCurrent={1} total={blogCount} pageSize={limit} onChange={onChange} />
				</div>
			)}
		</>
	);
};

export default BlogContent;
